module.exports = __webpack_public_path__ + "img/uk.8f287456.svg";